import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl2 = `${httpUrl.host}/gy-apartment`
let baseUrl85 = `${httpUrl.host}/gy-apartment`

let api = {
  // 预约数据
  getValueaddVenueRecordStatistics: `${baseUrl}/valueaddOverview/getValueaddVenueRecordStatistics`,

  // 预约统计
  getValueaddStatistics: `${baseUrl}/valueaddOverview/getValueaddStatistics`,

  // 添加服务类目
  valueAddItemAdd: `${baseUrl}/valueaddItem/add`,

  // 查询类目详情
  getValueAddItemByCode: `${baseUrl}/valueaddItem/getByCode`,

  // 修改类目详情
  updateValueAddItemChild: `${baseUrl}/valueaddItem/update`,

  // 删除服务类目
  valueAddItemDeleteByCodes: `${baseUrl}/valueaddItem/deleteByCodes`,

  // 服务类目分页
  getValueAddItemPage: `${baseUrl}/valueaddItem/getPage`,

  // 服务类目列表
  getValueAddItemList: `${baseUrl}/valueaddItem/getList`,

  // 子类目分页
  getValueAddItemChildPage: `${baseUrl}/valueaddItemChild/getPage`,

  // 添加子类目
  addValueAddItemChild: `${baseUrl}/valueaddItemChild/add`,

  // 查询子类目详情
  getValueAddItemChildByCode: `${baseUrl}/valueaddItemChild/getByCode`,

  // 修改子类目
  updateValueAddItemChildDetail: `${baseUrl}/valueaddItemChild/update`,

  // 删除子类目
  valueAddItemChildDeleteByCodes: `${baseUrl}/valueaddItemChild/deleteByCodes`,

  // 添加服务商
  valueAddProviderAdd: `${baseUrl}/valueaddProvider/add`,

  // 服务商分页
  getValueAddProviderPage: `${baseUrl}/valueaddProvider/getPage`,

  // 服务商详情
  getValueAddProviderByCode: `${baseUrl}/valueaddProvider/getByCode`,

  // 服务商详情
  updateValueAddProvider: `${baseUrl}/valueaddProvider/update`,

  // 删除服务商
  valueAddProviderDeleteByCodes: `${baseUrl}/valueaddProvider/deleteByCodes`,

  // 预约记录分页
  getValueAddVenueRecordPage: `${baseUrl}/valueaddVenueRecord/getPage`,

  // 收费记录分页
  getValueAddConsumptionRecordPage: `${baseUrl}/valueaddConsumptionRecord/getPage`,

  // 查询账户列表
  getAccountList: `${baseUrl2}/paymentItem/getAccountList`,

  // 上传图片
  uploadImg: `${baseUrl85}/yqNews/uploadImg`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/ValueAdded.js